import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';

const Cookies = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-20">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto">
          <Card className="border-0 shadow-xl">
            <CardHeader>
              <CardTitle className="text-3xl">Cookie-Einstellungen</CardTitle>
            </CardHeader>
            <CardContent className="space-y-6 text-gray-700">
              <div>
                <h3 className="font-semibold text-lg text-gray-900 mb-2">Was sind Cookies?</h3>
                <p className="text-sm">
                  Cookies sind kleine Textdateien, die auf Ihrem Computer oder Mobilgerät gespeichert werden, 
                  wenn Sie unsere Website besuchen. Sie helfen uns, Ihre Präferenzen zu speichern und Ihr 
                  Nutzungserlebnis zu verbessern.
                </p>
              </div>

              <div>
                <h3 className="font-semibold text-lg text-gray-900 mb-2">Notwendige Cookies</h3>
                <p className="text-sm">
                  Diese Cookies sind für das Funktionieren der Website unbedingt erforderlich. 
                  Ohne diese Cookies können bestimmte Funktionen nicht gewährleistet werden.
                </p>
              </div>

              <div>
                <h3 className="font-semibold text-lg text-gray-900 mb-2">Analyse-Cookies</h3>
                <p className="text-sm">
                  Diese Cookies helfen uns zu verstehen, wie Besucher mit unserer Website interagieren. 
                  Die gesammelten Informationen werden anonymisiert und dienen der Verbesserung unserer Website.
                </p>
              </div>

              <div>
                <h3 className="font-semibold text-lg text-gray-900 mb-2">Marketing-Cookies</h3>
                <p className="text-sm">
                  Diese Cookies werden verwendet, um Werbung relevanter für Sie und Ihre Interessen zu gestalten. 
                  Sie können auch dazu dienen, die Anzahl der Anzeigen zu begrenzen.
                </p>
              </div>

              <div className="bg-gray-100 p-4 rounded-lg">
                <h3 className="font-semibold text-lg text-gray-900 mb-2">Ihre Cookie-Einstellungen</h3>
                <p className="text-sm mb-4">
                  Sie können Ihre Cookie-Einstellungen jederzeit anpassen. Bitte beachten Sie, dass das 
                  Deaktivieren bestimmter Cookies die Funktionalität der Website beeinträchtigen kann.
                </p>
                <p className="text-sm text-gray-500">
                  Weitere Informationen finden Sie in unserer <a href="/datenschutz" className="text-red-600 hover:underline">Datenschutzerklärung</a> und 
                  unserer <a href="/cookie-richtlinie" className="text-red-600 hover:underline">Cookie-Richtlinie</a>.
                </p>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default Cookies;
